import { render, staticRenderFns } from "./index.vue?vue&type=template&id=99f79a44&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=99f79a44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f79a44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99f79a44')) {
      api.createRecord('99f79a44', component.options)
    } else {
      api.reload('99f79a44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=99f79a44&scoped=true", function () {
      api.rerender('99f79a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aim/index.vue"
export default component.exports